import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/ads`,
});

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// ════════════════════════════════════════════════════════════════════════════
// 📤 Upload Media (image/video) → Cloudinary
//    multipart/form-data — Content-Type header set pannakoodathu (axios auto set panum)
// ════════════════════════════════════════════════════════════════════════════
export async function uploadAdMedia(file) {
  try {
    const formData = new FormData();
    formData.append("media", file);
    const res = await API.post("/admin/upload", formData, {
      headers: { ...authHeader() },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

export async function deleteAdMedia(publicId) {
  try {
  
    const res = await API.delete(`/admin/delete/${publicId}`, {
      headers: { ...authHeader() },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// ➕ Create Ad
// ════════════════════════════════════════════════════════════════════════════
export async function createAd(payload) {
  try {
    const res = await API.post("/admin/create", payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// 📋 Get All Ads (with status filter + pagination)
// ════════════════════════════════════════════════════════════════════════════
export async function getAllAds({ status = "", page = 1, limit = 15 } = {}) {
  try {
    const params = { page, limit };
    if (status) params.status = status;
    const res = await API.get("/admin/all", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      params,
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// 📊 Get Analytics Summary
// ════════════════════════════════════════════════════════════════════════════
export async function getAdAnalytics() {
  try {
    const res = await API.get("/admin/analytics", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// ✏️ Update Ad
// ════════════════════════════════════════════════════════════════════════════
export async function updateAd(adId, payload) {
  try {
    const res = await API.put(`/admin/${adId}`, payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// ✅ Toggle Active / Paused
// ════════════════════════════════════════════════════════════════════════════
export async function toggleAdStatus(adId) {
  try {
    const res = await API.patch(`/admin/${adId}/toggle`, {}, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// ❌ Reject Ad
// ════════════════════════════════════════════════════════════════════════════
export async function rejectAd(adId, reason) {
  try {
    const res = await API.patch(`/admin/${adId}/reject`, { reason }, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// 🗑️ Delete Ad
// ════════════════════════════════════════════════════════════════════════════
export async function deleteAd(adId) {
  try {
    const res = await API.delete(`/admin/${adId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}